export enum OmniUsuarioEnum {
  OMNI_KEYCLOAK_CLIENTID = 'omni-keycloak-clientId',
  OMNI_KEYCLOAK_REDIRECTURI = 'omni-keycloak-redirectUri',
  NO_BAR = 'no-bar',
}
